import { morphTimelines } from './animation';

/**
 * ボタンをクリックしたときに再生／停止を切り替えるユーティリティ関数
 * @param {string} buttonSelector - トグルボタンのセレクタ
 * @param {Function} callback - ボタンクリック時に実行するコールバック
 */
export function toggleAutoplay(buttonSelector, callback) {
	// 既存のイベントを解除してから新たにクリックイベントを設定
	$(buttonSelector).off().on('click', function (event) {
		$(this).toggleClass('is-stop'); // ボタンに停止状態クラスを付与／削除
		callback(event);                // 外部で渡したコールバックを実行
	});
}

/**
 * 使い方例（コメントアウト済み）
 *
 * toggleAutoplay('.js-play_toggle03', () => {
 *     if ($(this).hasClass('is-stop')) {
 *         // 再生処理
 *         morphTimelines.forEach(timeline => timeline.play());
 *     } else {
 *         // 停止処理
 *         morphTimelines.forEach(timeline => timeline.pause());
 *     }
 * });
 */
